import { actions } from '.';

export function toggleModal(payload) {
  return {
    type: actions.TOGGLE_MODAL,
    payload
  };
}
